import React from "react";

const CommonHeader = ({ left, right }) => {
  return (
    <div className="w-full h-20 px-5 xs:px-2 py-2 flex flex-col justify-end">
      <div className="w-full flex justify-between items-center">
        <div>{left}</div>
        <div>{right}</div>
      </div>
    </div>
  );
};

export default CommonHeader;
